import {
  addExpenseApi,
  getCommonExpenseApi,
  getUserAccountList,
  handleKeyDown,
  uploadFiles,
  venderDropdownApi,
} from "_services";
import { getConsignorListData } from "_services/accountsServices/consignorServices";
import { getSupplierListData } from "_services/accountsServices/supplierServices";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CustomSelect,
  SkeletonInput,
  CityDropdownForTrip,
} from "components";
import { UserContext } from "context";
import { addTransationConsignor, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddAccountingAccount from "modals/AddAccountingAccount";
import AddEditModal from "modals/AddEditModal";
import React, { useCallback, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";
import './otherExp.css'
import { getDriverDropdownListData, getFuelApi } from "_services/dropdownServices/dropdownService";
import ConfirmModalFor from "modals/ConfirmModalFor";
import { Images } from "constants";
import PayNowAccountNotifyModal from "modals/PayNowAccountNotifyModal";

const OtherExpenseModal = (props) => {
  const {
    tripId,
    modalType,
    closeModal,
    callBackFreight,
    isOpen,
    transactionList,
    venderDetailsFun = () => { },
    tripDetais,
    callbackEaesbuzz,
    setIsOpenPayNow
  } = props;

  const initiFrom = {
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    vendor_type: 4,
    vendor_id: "",
    vendor_account: "",
    lr_id: "",
    trip_id: tripId,
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
    vendor_bank_account: "",
    isCheck: false,
    no_of_days: 0,
    days_rate: 0,
    perc_of_revenue: 0
  };

  const { masterData, globTripDetails, bankDetails, setBankDetails } = useContext(UserContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [expenseTypeList, setExpenseTypeList] = useState([]);
  const [expenseAccount, setExpenseAccount] = useState([]);
  const [venderList, setVenderList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [partyList, setPartyList] = useState([]);
  const [accountType, setAccountType] = useState();
  const [accountList, setAccountList] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [accountLoading, setAccountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [commExpenseList, setCommExpenseList] = useState([]);
  const [isOpenFuelModal, setIsOpenFuelModal] = useState(false);
  const [accountAddShow, setAccountAddShow] = useState(false);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [isCheck, setIsCheck] = useState(false);
  const [driverList, setDriverList] = useState([]);
  const [fuelStationList, setFuelStationList] = useState([]);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [imageDetele, setImageDetele] = useState(null);
  const [selectedVendorDetails, setSelectedVendorDetails] = useState({});
  const [categoryDetails, setCategoryDetails] = useState({});
  const [bankRequiredDetails, setBankRequiredDetails] = useState({})
  const [payNowAccountCreate, setpayNowAccountCreate] = useState(false);
  const [easeBuzzId, setEaseBuzzId] = useState("")



  const toPayList = masterData?.vendor_type_list.map((item) => {
    return { label: item?.name, value: item?.id }
  });
  const [selectedOption, setSelectedOption] = useState(toPayList[3]);

  // Lazy Loading Fetch Functions
  const fetchSupplier = useCallback(async (search, page, limit) => {
    try {
      const response = await getSupplierListData({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        firm_id: tripDetais?.firm_id?._id
      });

      if (response?.responseCode === 200) {
        const suppliers = response.data.supplier_list.map(supplier => ({
          ...supplier,
          label: supplier.name,
          value: supplier._id
        }));

        return {
          items: suppliers,
          total: response.data.total_record || suppliers.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching suppliers:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const fetchVendor = useCallback(async (search, page, limit) => {
    try {
      const response = await venderDropdownApi({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        firm_id: tripDetais?.firm_id?._id
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.vendor_list.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching vendors:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const fetchParty = useCallback(async (search, page, limit) => {
    try {
      const response = await getConsignorListData({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        firm_id: tripDetais?.firm_id?._id
      });

      if (response?.responseCode === 200) {
        const parties = response.data.consignor_list.map(party => ({
          ...party,
          label: party.name,
          value: party._id
        }));

        return {
          items: parties,
          total: response.data.total_record || parties.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching parties:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const fetchDriver = useCallback(async (search, page, limit) => {
    try {
      const response = await getDriverDropdownListData({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        driver_type: [2],
        firm_id: tripDetais?.firm_id?._id
      });

      if (response?.responseCode === 200) {
        const drivers = response.data.driver_list
          // .filter((item) => item?.driver_type != 1)
          .map(driver => ({
            ...driver,
            label: driver.name,
            value: driver._id
          }));

        return {
          items: drivers,
          total: response.data.total_record || drivers.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching drivers:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const fetchFuelStation = useCallback(async (search, page, limit) => {
    try {
      const response = await getFuelApi({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        firm_id: tripDetais?.firm_id?._id
      });

      if (response?.responseCode === 200) {
        const fuelStations = response.data.fuelstation_list.map(station => ({
          ...station,
          label: station.name,
          value: station._id
        }));

        return {
          items: fuelStations,
          total: response.data.total_record || fuelStations.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching fuel stations:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const listMap = {
    1: {
      label: "Select Supplier",
      list: supplierList,
      fetchData: fetchSupplier
    },
    2: {
      label: "Select Party",
      list: partyList,
      fetchData: fetchParty
    },
    3: {
      label: "Select Driver",
      list: driverList,
      fetchData: fetchDriver
    },
    4: {
      label: "Select Vendor",
      list: venderList,
      fetchData: fetchVendor
    },
    5: {
      label: "Select Fuel Station",
      list: fuelStationList,
      fetchData: fetchFuelStation
    },
    6: { label: "Select Fuel Card", list: [] },
    7: { label: "Select Fastag", list: [] },
    8: { label: "Select Staff", list: [] },
  };

  const optionMap = masterData?.vendor_type_list.reduce((acc, item) => {
    acc[item.id] = {
      label: listMap[item.id]?.label || `Select ${item.name}`,
      name: "vendor_id",
      list: listMap[item.id]?.list || [],
      fetchData: listMap[item.id]?.fetchData,
      value: form?.vendor_id,
    };
    return acc;
  }, {});

  const balance =
    props?.transactionList?.freight_summary?.freight_summary?.balance;

  useEffect(() => {
    getMasterFreight();
    setForm((prev) => ({ ...prev, vendor_type: toPayList[3].value }));
  }, []);

  useEffect(() => {
    if (props?.accountList?.length > 0) {
      let list = props?.accountList?.map((i) => {
        return {
          ...i,
          label: i?.bank_name || i?.account_name || i?.upi_id,
          value: i?._id,
        };
      });
      setBankAccountList(list);
    } else {
      setBankAccountList([]);
    }
  }, [props?.accountList]);


  useEffect(() => {
  if (
    form?.account_sub_category &&
    form?.account_category &&
    expenseAccount.length &&
    form?.account_sub_category != 1  &&  // ✅ To Pay skip
    form?.account_sub_category != 11     // ✅ Cash skip
  ) {
    if (form?.account_id === "") {
      getAccountListHandler();
    }
  }
}, [form?.account_sub_category, form?.account_category, expenseAccount, form?.account_id, form?.sub_category]);

  useEffect(() => {
    let value = false;

    // 1️⃣ bankRequiredDetails rule
    if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 2) {
      value = true;
    }

    // 2️⃣ form/account rules
    if (form?.account_id === "") {
      value = false;
    }

    if (form?.account_sub_category == 27 || form?.account_sub_category == 28) {
      value = true;
    }

    // Final update in one place:
    setIsCheck(value);

  }, [
    bankRequiredDetails,
    form?.account_sub_category,
    form?.account_id,
  ]);


  useEffect(() => {
    if (accountType) {
      setForm((prev) => ({ ...prev, account_id: "" }));
    }
  }, [accountType]);

  useEffect(() => {

    if (selectedOption?.value ) {
      setForm((prev) => ({ ...prev, vendor_type: selectedOption.value, vendor_id: "" }));
    }
    setSelectedVendorDetails({})

  }, [selectedOption.value]);


  useEffect(() => {
    if (selectedOption?.value) {
      setForm((prev) => ({
        ...prev,
        vendor_account: "",
        vendor_id: ""
      }));
      setBankDetails("");
      setSelectedVendorDetails({});
    }
  }, [selectedOption?.value]);


  useEffect(() => {
  // Jab payment mode change ho, vendor details clear karo
  setForm((prev) => ({
    ...prev,
    vendor_id: "",
    vendor_account: "",
    vendor_bank_account: ""
  }));
  setSelectedVendorDetails({});
  setBankDetails("");
}, [form.vendor_type]);

  useEffect(() => {
    setBankDetails("");
    setForm((prev) => ({
      ...prev,
      vendor_bank_account: "",
    }));
  }, [form?.vendor_id]);

  useEffect(() => {
    if (form?.sub_category) {
      getCommonExpense(form?.sub_category);
      setForm((prev) => ({
        ...prev,
        expense_category: ""
      }));
    }
  }, [form?.sub_category])

  useEffect(() => {

    // if (form?.account_sub_category == 1 || form?.account_sub_category == 27 || form?.account_sub_category == 28) {
    //   if (form?.sub_category == 1) {
    //     setSelectedOption(toPayList[0])
    //   } else if (form?.sub_category == 2) {
    //     setSelectedOption(toPayList[2])
    //   }
    // }
     setBankDetails("");

    if (form?.account_sub_category == 11) {
      setSelectedOption({})
    }
  }, [form?.sub_category, form?.account_sub_category]);

  useEffect(() => {
    if (!isCheck) {
      setBankDetails("");
      if (form?.vendor_bank_account) {
        setForm((prev) => ({
          ...prev,
          vendor_bank_account: "",
        }));
      }
    } else {
      setForm((prev) => ({
        ...prev,
        vendor_bank_account: bankDetails?._id,
      }));
      setFormError((pre) => ({ ...pre, vendor_account: "" }))
    }
  }, [isCheck]);

  useEffect(() => {
    if (bankDetails && form?.category) {
      setForm({ ...form, vendor_bank_account: bankDetails?._id });
      setFormError((pre) => ({ ...pre, vendor_bank_account: "" }))
    }
  }, [bankDetails, form?.category]);

  // Prefill vendor details when vendor_id exists
  useEffect(() => {
    if (form?.vendor_id && form?.vendor_type) {
      const fetchVendorDetails = async () => {
        const vendorType = form.vendor_type;
        const fetchFunction = listMap[vendorType]?.fetchData;

        if (fetchFunction) {
          try {
            const result = await fetchFunction("", 1, 1000);
            const vendor = result.items.find(item => item._id === form.vendor_id);
            if (vendor) {
              setSelectedVendorDetails(vendor);
            }
          } catch (error) {
            console.error("Error prefilling vendor:", error);
          }
        }
      };

      fetchVendorDetails();
    } else {
      setSelectedVendorDetails({});
    }
  }, [form?.vendor_id]);

  // useEffect(() => {
  //   setForm((pre) => ({ ...pre, vendor_id: selectedVendorDetails?._id }))
  // }, [selectedVendorDetails])

  const modifyExpenseTypeList = useCallback(() => {
    if (form?.sub_category == 1) {
      const filtermode = expenseAccount.filter((item) => item.value != 1);
      return [{ label: 'To Pay', value: 1, category_id: 1 }, ...filtermode]
    } else {
      const filtermode = expenseAccount.filter((item) => item.value != 1 && item.value != 28);

      return [{ label: 'To Receive', value: 1, category_id: 1 }, ...filtermode]
    }
  }, [form?.sub_category]);

  useEffect(() => {
    if (form?.sub_category) {

      if (form?.account_sub_category == 28 && form?.sub_category == 2) {
        setForm((f) => ({ ...f, account_sub_category: 1 }))
      }
    }
  }, [form?.sub_category]);

  const orderOfVender = [4, 2, 1, 3, 5, 6, 7, 8];
  const sortedData = toPayList.sort(
    (a, b) => orderOfVender.indexOf(a.value) - orderOfVender.indexOf(b.value)
  );

  const visibleOptions = sortedData.filter(opt =>
    [1, 2, 4].includes(opt.value)
  );

  const dropdownOptions = sortedData.filter(opt =>
    ![1, 2, 4, 6, 7, 8].includes(opt.value)
  );

  const getMasterFreight = async () => {
    try {
      const details = masterData?.supplier_other_charges?.sub_type?.map(
        (item) => {
          return {
            label: item?.name,
            value: item?.id,
            id: item?._id,
            status: item?.status,
            category_id: masterData?.supplier_other_charges?.id,
            type: masterData?.supplier_other_charges?.type,
          };
        }
      );

      const detailsAccount =
        masterData?.market_account_category?.sub_category
          ?.filter((k) => k.id !== 10)
          ?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
              category_id: masterData?.market_account_category?.id,
            };
          })
          ?.concat({
            label: "To Pay",
            value: 1,
            category_id: masterData?.market_account_category?.id,
          });

      const order = [1, 3, 2, 27, 14, 28];
      const sortedData = detailsAccount.sort(
        (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
      );

      const detailsAccountOwn =
        masterData?.own_account_category?.sub_category
          ?.filter((k) => k.id !== 10)
          ?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
              category_id: masterData?.own_account_category?.id,
            };
          })
          ?.concat({
            label: "To Pay",
            value: 1,
            category_id: masterData?.own_account_category?.id,
          });

      const order1 = [1, 11, 3, 2, 27, 14, 28];
      const sortedData1 = detailsAccountOwn.sort(
        (a, b) => order1.indexOf(a.value) - order1.indexOf(b.value)
      );

      if (sortedData && details) {
        if (modalType != "receipt") {
          setForm({
            ...form,
            trip_id: tripId,
            category: details[0]?.category_id,
            sub_category: details[0]?.value,
            account_category:
              globTripDetails?.vehicle_ownership == 2
                ? sortedData[0]?.category_id
                : sortedData1[0]?.category_id,
            account_sub_category:
              globTripDetails?.vehicle_ownership == 2
                ? sortedData[0]?.value
                : sortedData1[0]?.value,
          });
        } else {
          setForm({
            ...form,
            trip_id: tripId,
            category: details[1]?.category_id,
            sub_category: details[1]?.value,
            account_category:
              globTripDetails?.vehicle_ownership == 2
                ? sortedData[0]?.category_id
                : sortedData1[0]?.category_id,
            account_sub_category:
              globTripDetails?.vehicle_ownership == 2
                ? sortedData[0]?.value
                : sortedData1[0]?.value,
          });
        }

        setExpenseTypeList(details);
        setExpenseAccount(
          globTripDetails?.vehicle_ownership == 2 ? sortedData : sortedData1
        );
      }
    } catch { }
  };


  const getCommonExpense = async (expense) => {
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        category_id: expense == 1 ? 5 : 4,
        sub_category_id: expense == 1 ? 3 : 2,
      };
      const res = await getCommonExpenseApi(payload);

      if (res?.responseCode === 200) {
        const details = res?.data?.categories?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setCommExpenseList(details);
        // setExpenseDetails(res?.data);
      } else {
      }
    } catch (error) { }
  };

  const getAccountListHandler = async (newParam = "") => {
    if (form?.account_sub_category == 1 || form?.account_sub_category == 11) return;
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        firm_id: tripDetais?.firm_id?._id
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setAccountList(details);
        if (details?.length) {
          const lastItem = details[details.length - 1];
          handleOnChange(
            "account_id",
            newParam == "new" ? lastItem?.value : details[0]?.value
          );

          if (form?.account_sub_category == 28) {
            setEaseBuzzId(details[0]?.eb_account_id)
          } else {
            setEaseBuzzId("")
          }
        } else {
          handleOnChange("account_id", "");
          if (details.length == 0 && form?.account_sub_category == 28) {
            setpayNowAccountCreate(true)
          }
        }
        const lastItem = details[details.length - 1];
        setBankRequiredDetails(newParam == "new" ? lastItem : details[0])


      } else {
        setAccountLoading(false);
        setAccountList([]);
      }
      if (form?.account_sub_category != 2 && form?.account_sub_category != 27 || form?.account_sub_category != 28) {
        setBankDetails("");
        setIsCheck(false);
      }

    } catch (error) {
      setAccountList([]);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj, isCheck, categoryDetails: categoryDetails?.calculation_type, },
        errorSchema.addOtherChargesSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitExpense = async (approve) => {
    const validationResult = await utils.checkFormError(
      { ...form, isCheck, categoryDetails: categoryDetails?.calculation_type, },
      errorSchema.addOtherChargesSchema
    );

    const payload = {
      type: form?.category ? parseInt(form?.category) : "",
      sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
      expense_category: form?.expense_category,
      amount: (form?.amount).toString(),
      date: utils.convertToISO(form?.txn_date, true),
      account_category: form?.account_category
        ? parseInt(form?.account_category)
        : "",
      account_sub_category: form?.account_sub_category
        ? parseInt(form?.account_sub_category)
        : "",
      account_id: form?.account_id ? form?.account_id : "",
      description: form?.description,
      vendor_type: parseInt(selectedOption?.value),
      vendor_id: form?.vendor_id || "",
      vendor_bank_account: form?.vendor_bank_account,
      lr_id: modalType == "consignor_claim" ? isOpen?._id : form?.lr_id,
      trip_id: tripId,
      branch_id: globTripDetails?.branch_id?._id,
      company_id: form?.company_id,
      vehicle_id: globTripDetails?.vehicle_id?._id,
      file: form?.file,
      is_approval: approve,
      no_of_days: (form?.no_of_days).toString(),
      days_rate: (form?.days_rate).toString(),
      perc_of_revenue: (form?.perc_of_revenue).toString()
    };

    if (validationResult === true) {

      if (approve == 0 && form?.account_sub_category == 28) {
        callbackEaesbuzz(
          easeBuzzId,
          form?.amount,
          {
            vendor_bank_account: {
              account_name: bankDetails?.account_name,
              account_number: bankDetails?.account_number,
              account_type: bankDetails?.account_type,
              bank_name: bankDetails?.bank_name,
              ifsc_code: bankDetails?.ifsc_code,
              upi_id: bankDetails?.upi_id
            }
          },
          payload
        );
        setIsOpenPayNow(true)
        return
      }

      approve == 0 ? setIsLoadding(true) : setIsLoadingSave(true);
      try {
        const res = await dispatch(
          modalType == "consignor_claim"
            ? addTransationConsignor(payload)
            : addTransationFreight(payload)
        );
        if (res?.payload?.responseCode === 200) {
          setIsLoadding(false);
          setIsLoadingSave(false);
          closeModal();
          callBackFreight();
        } else {
          setIsLoadding(false);
          setIsLoadingSave(false);
        }
      } catch {
        setIsLoadding(false);
        setIsLoadingSave(false);
      }
    } else {
      setFormError(validationResult);
    }
  };



  const modifyProps = {
    ...props,
    isLoadding: isLoadding,
    disabled: isLoadding,
    onSubmit: onSubmitExpense,
    isLoadingSave: isLoadingSave,
    saveButton: form?.account_sub_category == 27 ,
    closeModal: () => {
      setBankDetails("");
      setForm(initiFrom);
      setFormError("");
      setSelectedVendorDetails({});
      closeModal();
    },
    submitTitle: form?.account_sub_category == 28 && "Pay Now",
    tripApprovalPermission: bankRequiredDetails?.trip_payment_approval || 0,
    submitbutton:form?.account_sub_category == 1 ? false:true

  };


  console.log(form)

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];
    newFromIput.splice(index, 1);
    setForm({ ...form, file: newFromIput });
    setConfirmModalShow(false);
    setImageDetele({})
  };

  const isExpense = form?.sub_category == 1;
  const categoryLabel = isExpense ? "Expense Category" : "Receipt Category";
  const categoryPlace = isExpense
    ? "Select Expense Category"
    : "Select Receipt Category";
  const categoryOptions = commExpenseList || [{ label: "", value: "" }];
  const selectedCategory = commExpenseList?.find(
    (i) => i.value === form?.expense_category
  );

  const callBackApi = (data) => {
    getCommonExpense(form?.sub_category);
    handleOnChange("expense_category", data?.category?._id);
    callBackFreight();
  };

  const addExpenseHandle = (data) => {
    setIsOpenFuelModal(true);
  };

  const addAccountHandle = () => {
    setAccountAddShow(true);
  };

  const callBackAddAccount = () => {
    getAccountListHandler("new")
  }

  const isSelected = (opt) => selectedOption.value === opt.value;

  const handleDelteSubmit = (index, el) => {
    setImageDetele({ index: index, el: el });
    setConfirmModalShow(true);
  }

  let openZoneModal = {
    isOpen: isOpenFuelModal,
    closeModal: (e) => setIsOpenFuelModal(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle:
      form?.sub_category == 1 ? "Add Trip Expenses" : "Add Trip Receipt",
    submitTitle:
      form?.sub_category == 1 ? "Add Trip Expenses" : "Add Trip Receipt",
    footerPart: true,
    label: form?.sub_category == 1 ? "Expenses Name" : "Receipt Name",
    placeholder:
      form?.sub_category == 1 ? "Enter Expenses Name" : "Enter Receipt Name",
    ApiPoint: addExpenseApi,
    callBackApi: callBackApi,
    payloadData: {
      category_id: (form?.sub_category == 1) == 1 ? 5 : 4,
      sub_category_id: (form?.sub_category == 1) == 1 ? 3 : 2,
    },
    titleName: "Trip",
  };

  let AddTransactionAccountModal = {
    isOpen: accountAddShow,
    closeModal: (e) => setAccountAddShow(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Account ",
    footerPart: true,
    submitTitle: "Add Account",
    callBackAddAccount: callBackAddAccount
  }

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => setConfirmModalShow(false),
    title: "Confirm",
    submitTitle: "Remove",
    onSubmit: () => documentRemove(imageDetele.index),
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
  };


  useEffect(() => {
    if (categoryDetails?.calculation_type == 2) {
      setForm((pre) => ({ ...pre, amount: pre?.no_of_days * pre?.days_rate }))
    }

    if (categoryDetails?.calculation_type == 3) {
      setForm((pre) => ({ ...pre, amount: Number(transactionList?.freight_summary?.total_freight * Number(pre?.perc_of_revenue)) / 100 }))
    }

  }, [form?.no_of_days, form?.days_rate, form?.perc_of_revenue,transactionList?.freight_summary?.total_freight])

  // useEffect(() => {
  //   if (bankRequiredDetails?.vendor_account === true) {
  //     setIsCheck(true)
  //   } else {
  //     setIsCheck(false)
  //   }
  // }, [bankRequiredDetails])


  let payNowAccountProps = {
    isOpen: payNowAccountCreate,
    closeModal: (e) => {
      setpayNowAccountCreate(false)
      setAccountType(1);
      setForm((pre) => ({ ...pre, account_sub_category: 1 }));
    },
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Pay Now ",
    // headerPart: true,
    footerPart: true,
    submitTitle: "Create Account",
    callBackAddAccount: callBackAddAccount
  }

  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body">
          <div className="_lrCl_offCavBody __otr_expCanva">
            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <CommonDatePicker
                    name="date"
                    label="Payment Receipt Date & Time"
                    startDate={form?.txn_date}
                    setStartDate={(data) => {
                      handleOnChange("txn_date", data);
                    }}
                    error={formError?.txn_date}
                    focus={!!formError?.txn_date}
                     maxDate={new Date()} 
                  />
                </div>
                <div className="singleDiv">
                  <div className="checkBx_lv" style={{ marginBottom: '12px' }}>
                    {expenseTypeList.map((i) => {
                      return (
                        <div className="_dualCheckr_bx" key={i?.value}>
                          <input
                            className="form-check-input"
                            id={i?.value}
                            type="radio"
                            name="sub_category"
                            checked={i.value == form.sub_category}
                            value={i.value}
                            onChange={({ target: { name, value } }) =>
                              handleOnChange(name, value)
                            }
                          />
                          <label htmlFor={i?.value} className="form-check-label">
                            {i?.label}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="singleDiv">
                  <CustomSelect
                    label={categoryLabel}
                    options={categoryOptions}
                    placeholder={categoryPlace}
                    onSelect={(data) => {
                      setCategoryDetails(data)
                      handleOnChange("expense_category", data.value)
                    }
                    }
                    value={selectedCategory || { label: "", value: "" }}
                    focus={!!formError?.expense_category}
                    error={formError?.expense_category}
                    isAddButton={true}
                    addButtonAction={addExpenseHandle}
                  />
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Description"
                    placeholder="Description"
                    name="description"
                    value={form?.description}
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    focus={!!formError?.description}
                    error={formError.description}
                  />
                </div>
                {categoryDetails?.calculation_type == 2 && <div className="singleDiv">
                  <div className="flxInr">
                    <div className="halfDiv">
                      <CommonInput
                        type="text"
                        label="No of Days"
                        placeholder="No of Days"
                        name="no_of_days"
                        onChange={({ target: { name, value } }) => {
                          handleOnChange(name, value);
                        }}
                        onKeyDown={handleKeyDown}
                        focus={!!formError?.no_of_days}
                        error={formError.no_of_days}
                        maxLength={3}
                      />
                    </div>

                    <div className="halfDiv">
                      <CommonInput
                        type="text"
                        label="Rate"
                        placeholder="Rate"
                        name="days_rate"
                        onChange={({ target: { name, value } }) => {
                          handleOnChange(name, value);
                        }}
                        onKeyDown={handleKeyDown}
                        focus={!!formError?.days_rate}
                        error={formError.days_rate}
                        maxLength={6}
                      />
                    </div>
                  </div>
                </div>}
                {categoryDetails?.calculation_type === 3 && <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="% of Revenue"
                    placeholder="% of Revenue"
                    name="perc_of_revenue"
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.perc_of_revenue}
                    error={formError.perc_of_revenue}
                    postText="%"
                    postAddon={true}
                    maxLength={3}
                  />
                </div>}
                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Amount (₹)"
                    placeholder="Amount"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    name="amount"
                    value={form.amount}
                    // onChange={({ target: { name, value } }) => {
                    //   handleOnChange(name, value);
                    // }}
                    onChange={({ target: { name, value } }) => {
                      if (/^0[0-9]/.test(value)) {
                        value = value.replace(/^0+/, ''); // "01" → "1"
                      }

                      // Allow "0." for decimals but not "0x" where x is digit
                      if (value === "0") {
                        handleOnChange(name, value);
                        return;
                      }
                      handleOnChange(name, value)
                    }}
                    maxLength={10}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.amount}
                    error={formError.amount}
                    disabled={categoryDetails?.calculation_type === 2 || categoryDetails?.calculation_type === 3}

                  />
                </div>
              </div>
            </div>

            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_payMode_hed">
                    <h4>Payment Mode</h4>
                    {modifyExpenseTypeList().map((i) => (
                      <button
                        key={i?.value}
                        className={`_baseSpan ${i?.value == form?.account_sub_category
                          ? ""
                          : "_bspDisable"
                          }`}
                        disabled={accountLoading}
                        name="account_sub_category"
                        value={i.value}
                        onClick={({ target: { name, value } }) => {
                          handleOnChange(name, value);
                          setAccountType(value);
                        }}
                      >
                        {i.label}
                      </button>
                    ))}
                  </div>
                </div>
                {(form?.account_sub_category != 11 &&
                  form?.account_sub_category != 1) && (
                    <>
                      {!accountLoading ? (
                        <div className="singleDiv">
                          <CustomSelect
                            label="Select Account"
                            name="account_id"
                            onSelect={(data) => {
                              handleOnChange("account_id", data.value);
                              setBankRequiredDetails(data)
                            }}
                            value={
                              form?.account_id
                                ? accountList?.find((i) => i.value == form?.account_id)
                                : { label: "", value: "" }
                            }
                            options={accountList}
                            focus={!!formError?.account_id}
                            error={formError.account_id}
                            isAddButton={form?.account_sub_category == 2}
                            addButtonAction={addAccountHandle}
                          />
                        </div>
                      ) : (
                        <SkeletonInput isLoading={accountLoading} />
                      )}
                    </>
                  )}
              </div>
            </div>

            <div className="_othrExp_recBx">
              <div className="__vendorBxs">
                <div className="_clPay_flex">
                  <h4>{form?.sub_category == 1 ? "Vendor Details" : "Customer Details"}</h4>
                  <div className='__splNw_tabBx' style={{ marginBottom: '5px', marginTop: '-5px' }}>
                    {visibleOptions.map((opt) => (
                      <button
                        key={opt.value}
                        className={`__splBtns ${isSelected(opt) ? '__splActive' : ''}`}
                        onClick={() => {
                          setSelectedOption(opt)
                          handleOnChange("vendor_type", opt.value);
                        }}
                      >
                        {opt.label}
                      </button>
                    ))}

                    <div className={`${dropdownOptions.find((opt) => opt.value === selectedOption.value) ? "__splSelectBx __splActive" : "__splSelectBx"} `}>
                      <CustomSelect
                        key={selectedOption.value}
                        options={dropdownOptions}
                        value={
                          dropdownOptions.find((opt) => opt.value === selectedOption.value) || null
                        }
                        onSelect={(selected) => {
                          setSelectedOption(selected)
                          handleOnChange("vendor_type", selected.value);
                        }}
                        placeholder={
                          dropdownOptions.find((opt) => opt.value === selectedOption.value)
                            ? selectedOption.label
                            : 'More'
                        }
                      />
                    </div>
                  </div>

                  {form?.vendor_type && (
                    <div className="singleDiv">
                      {optionMap[selectedOption?.value]?.fetchData ? (
                        <CityDropdownForTrip
                          label={optionMap[selectedOption?.value]?.label}
                          placeholder={optionMap[selectedOption?.value]?.label}
                          fetchData={optionMap[selectedOption?.value]?.fetchData}
                          pageSize={20}
                          onChange={(data) => {
                            handleOnChange("vendor_id", data._id);
                            setSelectedVendorDetails(data);
                            venderDetailsFun({
                              vender_type: selectedOption.value,
                              vender_id: data._id
                            });
                          }}
                          selectedItem={selectedVendorDetails._id ? selectedVendorDetails : null}
                          error={formError.vendor_id}
                          errorMessage={formError?.vendor_id}
                        />
                      ) : (
                        <CustomSelect
                          label={optionMap[selectedOption?.value]?.label}
                          options={optionMap[selectedOption?.value]?.list || []}
                          name={optionMap[selectedOption?.value]?.name}
                          onSelect={(data) => {
                            handleOnChange("vendor_id", data.value);
                            venderDetailsFun({
                              vender_type: selectedOption.value,
                              vender_id: data.value
                            });
                          }}
                          placeholder={optionMap[selectedOption?.value]?.label}
                          value={
                            form?.vendor_id
                              ? optionMap[selectedOption?.value]?.list?.find(
                                (f) => f.value == form?.vendor_id
                              )
                              : { label: "", value: "" }
                          }
                          error={formError.vendor_id}
                          focus={!!formError?.vendor_id}
                        />
                      )}
                    </div>
                  )}

                  {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && form?.vendor_type && (
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        checked={isCheck}
                        disabled={form?.account_sub_category == 28 || form?.account_sub_category == 27 || bankRequiredDetails?.vendor_account === true}
                        onChange={({ target: { name, checked } }) => {
                          if (form?.account_sub_category == 2 && !form?.vendor_id) {
                            toast.error(`Please ${optionMap[selectedOption?.value]?.label} first`)
                            return
                          } else {
                            setIsCheck(checked);
                          }
                          handleOnChange("isCheck", checked);
                        }}

                      />
                      <label htmlFor="vehicle1"> {`${optionMap[selectedOption?.value]?.label ? optionMap[selectedOption?.value]?.label : "Select"} Bank Account`}</label>
                      <br />
                    </div>
                  )}

                  {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && isCheck && (
                    <div className="singleDiv"
                      onClick={() => {
                        if (form?.vendor_id) {
                          props?.setCanvasOpen(true);
                          venderDetailsFun({ vender_type: selectedOption.value, vender_id: form?.vendor_id })
                        } else {
                          toast.error(`Please ${optionMap[selectedOption?.value]?.label} first`)
                        }
                      }}
                    >
                      <CustomSelect
                        label={selectedOption?.value ? `${optionMap[selectedOption?.value]?.label} Account ` : "Select Account"}
                        options={bankAccountList}
                        disabled={!isCheck}
                        openList={false}
                        value={
                          bankDetails
                            ? bankAccountList?.find(
                              (i) => i?.value === bankDetails?._id
                            )
                            : { label: "", value: "" }
                        }
                        focus={!!formError?.vendor_bank_account}
                        error={formError.vendor_bank_account}

                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_attatchmentBxs">
                    <div className="__addExp_fileBx">
                      <h4>Attachment</h4>
                      <input
                        type="file"
                        id="_fileUpload"
                        onClick={(e) => {
                          if (form?.file?.length >= 5) {
                            e.preventDefault(); // stop opening file dialog
                            toast.error("You can upload only 5 files");
                          }
                        }}
                        onChange={(e) => handleFileChange(e)}
                      />
                      <label htmlFor="_fileUpload" className="_uploadBtn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                        >
                          <path
                            d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>{loading ? "Uploading" : "Add File"}</span>
                      </label>
                      {formError?.file && (
                        <span className="input_drop_error">
                          {formError?.file}
                        </span>
                      )}
                    </div>
                    <div className="img_fnex_src">
                      {form?.file?.length > 0 &&
                        form?.file?.map((el, index) => {
                          return (
                            <div className="pos-relative" key={index}>
                              <img
                                className="_pdfIcon_sigxe"
                                src={`${masterData?.s3_url}${el?.path}`}
                                alt=""
                              />
                              <span className="_clDel_icon">
                                <IoCloseCircle
                                  onClick={() =>
                                    handleDelteSubmit(index, el)
                                  }
                                />
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonCanvas>
      {isOpenFuelModal && <AddEditModal {...openZoneModal} />}
      {accountAddShow && <AddAccountingAccount {...AddTransactionAccountModal} />}
      {payNowAccountCreate && <PayNowAccountNotifyModal {...payNowAccountProps} />}
      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx">
              Are you sure you want to delete this image?
            </p>
          </>
        </ConfirmModalFor>
      )}
    </div>
  );
};

export default OtherExpenseModal;
